/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTaskBudgetCostCommand } from '../../models/create-project-task-budget-cost-command';
import { CreateProjectTaskBudgetCostCommandResult } from '../../models/create-project-task-budget-cost-command-result';

export interface ApiTaskBudgetCostCreateTaskBudgetCostPost$Params {
      body?: CreateProjectTaskBudgetCostCommand
}

export function apiTaskBudgetCostCreateTaskBudgetCostPost(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostCreateTaskBudgetCostPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>;
    })
  );
}

apiTaskBudgetCostCreateTaskBudgetCostPost.PATH = '/api/TaskBudgetCost/CreateTaskBudgetCost';
